export function canUseAiTemplateBuilder(accountMaster, siteMaster) {
    const account = accountMaster?.accountMaster || accountMaster
    const beta = Boolean(account?.beta?.aiTemplateBuilder)
    return beta && (siteMaster?.siteId == 1 || siteMaster?.aiEnabled === true)
}

export function composeGenerateRequestBody({
    kind = 'email',
    prompt,
    pastedContent,
    companyAbout,
    message,
    websiteUrl,
    persistCompanyProfile,
    sourceThemeId,
    sourceTemplateId,
    noStyle,
    templateName,
    campaignId,
    landingName,
    useAccountBranding = false
}) {
    const body = {
        useAccountBranding
    }

    const trimmedPrompt = typeof prompt === 'string' ? prompt.trim() : ''
    const trimmedPasted = typeof pastedContent === 'string' ? pastedContent.trim() : ''
    const trimmedAbout = typeof companyAbout === 'string' ? companyAbout.trim() : ''
    const trimmedMessage = typeof message === 'string' ? message.trim() : ''
    const trimmedWebsite = typeof websiteUrl === 'string' ? websiteUrl.trim() : ''
    const trimmedName = typeof templateName === 'string' ? templateName.trim() : ''
    const trimmedLandingName = typeof landingName === 'string' ? landingName.trim() : ''

    if (trimmedPrompt) body.prompt = trimmedPrompt
    if (trimmedPasted) body.pastedContent = trimmedPasted
    if (trimmedAbout) body.companyAbout = trimmedAbout
    if (trimmedMessage) body.message = trimmedMessage
    if (trimmedWebsite) body.websiteUrl = trimmedWebsite
    if (persistCompanyProfile) body.persistCompanyProfile = true
    if (noStyle) body.noStyle = true
    if (sourceThemeId) body.sourceThemeId = Number(sourceThemeId)
    if (sourceTemplateId) body.sourceTemplateId = Number(sourceTemplateId)
    if (trimmedName) body.templateName = trimmedName
    if (campaignId) body.campaignId = Number(campaignId)
    if (kind === 'landing') {
        body.name = trimmedLandingName.length >= 4 ? trimmedLandingName : 'AI landing page'
    }

    return body
}
